
const API_URL = window.location.href.indexOf("localhost") >= 0 ? 'https://ankieta.yatta.pl/api.php?a=' : '/api.php?a=';

import store from '@/store/index'
export default async function(action,data = {}){
    let method = Object.keys(data).length === 0 && data.constructor === Object ? 'GET' : 'POST';

    let headers = {};
    if(store.getters.isAuth) headers['ADMINHASH'] = store.getters.getAuthToken;

    return fetch(`${API_URL}${action}`,{
        method : method,
        body : method == "POST" ? JSON.stringify(data) : null,
        headers : headers
    })
    .then(res => res.json());
}